/**
 * CES Navtab Section JavaScript
 * 导航标签页section交互逻辑
 * 实现：从某个位置开始 sticky，滚动时自动定位，固定时隐藏全站导航栏
 */

(function() {
    'use strict';

    /**
     * 初始化导航标签页
     * @param {string} sectionId - Section ID
     */
    window.initNavtab = function(sectionId) {
        const navtabSection = document.getElementById('shopify-section-' + sectionId);
        const navtab = document.getElementById(sectionId + '-ces-navtab');
        const siteHeader = document.getElementById('site-header');
        const scrollableContainer = navtab ? navtab.querySelector('.nav-ces-tab-items-bg') : null;
        if (!navtabSection || !navtab || !scrollableContainer) {
            return;
        }
        let navtabHeight = navtab.offsetHeight;
        let siteHeaderHeight = siteHeader ? siteHeader.offsetHeight : 0;
        const nodes = Array.prototype.slice.call(navtab.getElementsByClassName('nav-ces-tab-item'), 0);
        const main = document.getElementById('main-content');

        if (!main || nodes.length === 0) {
            return;
        }

        let isFixed = false;
        let scrollTimer = null;
        let placeholder = null; // 占位元素，用于标记导航栏的原始位置
        
        // 获取顶部导航栏高度配置
        const headerHeightMobile = parseInt(navtab.getAttribute('data-header-height-mobile') || '48', 10);
        const headerHeightDesktop = parseInt(navtab.getAttribute('data-header-height-desktop') || '61', 10);
        
        // 获取当前应该使用的顶部导航栏高度
        function getHeaderHeight() {
            return window.innerWidth >= 1024 ? headerHeightDesktop : headerHeightMobile;
        }

        // 使用 IntersectionObserver 监听视口，判断导航栏是否应该固定
        let stickyObserver = null;
        let sentinel = null;
        
        // 使用 IntersectionObserver 监听 navtab 是否在视口内
        let viewportObserver = null;
        
        function updateStickyState(shouldBeFixed) {
            if (shouldBeFixed !== isFixed) {
                isFixed = shouldBeFixed;
                
                if (isFixed) {
                    // 导航栏固定时，创建占位元素记录原始位置
                    if (!placeholder) {
                        placeholder = document.createElement('div');
                        placeholder.style.position = 'absolute';
                        placeholder.style.width = '1px';
                        placeholder.style.height = '65px';
                        placeholder.style.pointerEvents = 'none';
                        placeholder.style.visibility = 'hidden';
                        placeholder.style.top = '0';
                        placeholder.style.left = '0';
                        navtabSection.parentNode.insertBefore(placeholder, navtabSection);
                    }
                    
                    // 获取导航栏的原始位置并设置占位元素位置
                    const navtabRect = navtabSection.getBoundingClientRect();
                    const navtabTop = navtabRect.top + window.scrollY;
                    placeholder.style.top = navtabTop + 'px';
                    
                    // 隐藏全站导航栏，并设置 top 值
                    document.body.classList.add('ces-navtab-fixed');
                    navtabSection.classList.add('ces-navtab-fixed');
                } else {
                    // 导航栏未固定时，显示全站导航栏
                    document.body.classList.remove('ces-navtab-fixed');
                    navtabSection.classList.remove('ces-navtab-fixed');
                    
                    // 如果占位元素存在，更新它的位置（因为导航栏位置可能改变）
                    if (placeholder) {
                        const navtabRect = navtabSection.getBoundingClientRect();
                        const navtabTop = navtabRect.top + window.scrollY;
                        placeholder.style.top = navtabTop + 'px';
                    }
                }
            }
        }
        
        // 创建或更新占位元素（仅在导航栏不是fixed状态时更新位置）
        function updatePlaceholder() {
            // 如果占位元素不存在，创建它
            if (!placeholder) {
                placeholder = document.createElement('div');
                placeholder.style.position = 'absolute';
                placeholder.style.width = '1px';
                placeholder.style.height = '65px';
                placeholder.style.pointerEvents = 'none';
                placeholder.style.visibility = 'hidden';
                placeholder.style.top = '0';
                placeholder.style.left = '0';
                navtabSection.parentNode.insertBefore(placeholder, navtabSection);
            }
            
            // 如果导航栏已经是fixed状态，占位元素位置已经记录，不需要更新
            if (isFixed) {
                return;
            }
            
            // 如果导航栏不是fixed状态，更新占位元素位置为当前导航栏位置
            const navtabRect = navtabSection.getBoundingClientRect();
            const navtabTop = navtabRect.top + window.scrollY;
            placeholder.style.top = navtabTop + 'px';
        }
        
        // 缓存导航栏原始位置，避免频繁计算
        let cachedNavtabTop = null;
        let cachedNavtabTopTimestamp = 0;
        const CACHE_DURATION = 100; // 缓存100ms
        
        // 手动检查当前是否应该吸顶
        function checkStickyState() {
            const currentScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
            const headerHeight = getHeaderHeight();
            
            // 获取导航栏的原始位置（使用缓存优化）
            let navtabTop;
            const now = Date.now();
            
            // 如果缓存有效且不是fixed状态，使用缓存
            if (cachedNavtabTop !== null && (now - cachedNavtabTopTimestamp) < CACHE_DURATION && !isFixed) {
                navtabTop = cachedNavtabTop;
            } else {
                // 需要重新计算
                if (isFixed && placeholder) {
                    // 如果已经是fixed状态，使用占位元素的位置
                    const placeholderRect = placeholder.getBoundingClientRect();
                    navtabTop = placeholderRect.top + currentScrollTop;
                } else {
                    // 否则直接获取导航栏位置
                    const navtabRect = navtabSection.getBoundingClientRect();
                    navtabTop = navtabRect.top + currentScrollTop;
                }
                // 更新缓存
                cachedNavtabTop = navtabTop;
                cachedNavtabTopTimestamp = now;
            }
            
            // 判断是否应该吸顶：当前滚动位置 >= 导航栏原始位置 - headerHeight
            // 同时确保滚动位置大于0（滚动到顶部时不应该吸顶）
            const shouldBeFixed = currentScrollTop > 0 && currentScrollTop >= (navtabTop - headerHeight);
            
            // 如果状态没有改变，直接返回（避免不必要的更新）
            if (shouldBeFixed === isFixed) {
                return;
            }
            
            // 更新状态
            updateStickyState(shouldBeFixed);
            
            // 状态改变时，清除缓存并更新占位元素
            cachedNavtabTop = null;
            updatePlaceholder();
        }
        
        // 监听窗口大小变化，更新 sentinel 位置和重新创建 observer
        let resizeTimer = null;
        function handleResize() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                // 如果导航栏已经是fixed状态，更新占位元素位置（因为resize可能导致位置改变）
                if (isFixed && placeholder) {
                    // 占位元素位置已经在updateStickyState中设置，但resize时可能需要更新
                    // 由于已经是fixed状态，占位元素位置应该保持不变（记录的是fixed前的原始位置）
                    // 但如果页面布局改变，可能需要重新计算
                    // 这里我们保持占位元素位置不变，因为它记录的是fixed前的原始位置
                } else {
                    // 如果导航栏不是fixed状态，更新占位元素位置
                    updatePlaceholder();
                }
                
                // 重新创建 observer 以更新 rootMargin（因为 headerHeight 可能改变）
                initStickyObserver();
                if (navtabHeight != navtab.offsetHeight) {
                    navtabHeight = navtab.offsetHeight;
                }
                if (siteHeaderHeight != siteHeader.offsetHeight) {
                    siteHeaderHeight = siteHeader.offsetHeight;
                }
                // 立即手动检查当前是否应该吸顶（设备切换时需要重新判断）
                checkStickyState();
            }, 100);
        }
        
        function initStickyObserver() {
            // 如果已存在，先清理
            if (stickyObserver) {
                stickyObserver.disconnect();
            }
            if (sentinel && sentinel.parentNode) {
                sentinel.parentNode.removeChild(sentinel);
            }
            
            // 更新占位元素位置
            updatePlaceholder();
            
            // 创建一个 sentinel 元素，用于检测导航栏是否到达顶部
            sentinel = document.createElement('div');
            sentinel.style.position = 'absolute';
            sentinel.style.top = '0';
            sentinel.style.left = '0';
            sentinel.style.width = '1px';
            sentinel.style.height = '65px';
            sentinel.style.pointerEvents = 'none';
            sentinel.style.visibility = 'hidden';
            
            // 将 sentinel 插入到导航栏 section 之前
            navtabSection.parentNode.insertBefore(sentinel, navtabSection);
            
            // 计算 sentinel 的位置（使用占位元素的位置或导航栏的原始位置）
            let navtabInitialTop;
            if (isFixed && placeholder) {
                // 如果已经是fixed状态，使用占位元素的位置
                const placeholderRect = placeholder.getBoundingClientRect();
                navtabInitialTop = placeholderRect.top + window.scrollY;
            } else {
                // 否则直接获取导航栏位置
                const navtabRect = navtabSection.getBoundingClientRect();
                navtabInitialTop = navtabRect.top + window.scrollY;
            }
            sentinel.style.top = (navtabInitialTop) + 'px';
            
            // 使用 IntersectionObserver 监听 sentinel 是否进入视口顶部
            const headerHeight = getHeaderHeight();
            stickyObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const currentScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
                    // 如果滚动位置小于 200，使用 scroll 判断而不是 intersection 判断
                    if (currentScrollTop < 200) {
                        // 使用 scroll 判断逻辑
                        checkStickyState();
                        return;
                    }
                    // 如果滚动到顶部（scrollTop <= 0），不应该吸顶
                    // 否则根据 sentinel 是否在视口内判断
                    const shouldBeFixed = currentScrollTop > 0 && !entry.isIntersecting;
                    updateStickyState(shouldBeFixed);
                });
            }, {
                root: null,
                rootMargin: `-${headerHeight}px 0px 0px 0px`,
                threshold: [0, 1]
            });
            
            stickyObserver.observe(sentinel);
        }
        
        // 绑定 resize 事件监听器（只绑定一次）
        window.addEventListener('resize', handleResize, { passive: true });
        
        // 检测是否在 iframe 环境中
        const isInIframe = window.self !== window.top;
        
        // 添加滚动监听器
        // 1. 在 iframe 环境中：作为 IntersectionObserver 的补充（因为 IntersectionObserver 可能不准确）
        // 2. 在非 iframe 环境中：当滚动位置小于 200 时，使用 scroll 判断而不是 intersection 判断
        let scrollCheckTimer = null;
        let rafId = null;
        let lastScrollTop = 0;
        let isScrolling = false;
        
        window.addEventListener('scroll', function() {
            const currentScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
            // 如果滚动位置小于 200，使用 scroll 判断
            if (currentScrollTop < 200) {
                // 如果滚动到顶部，强制取消吸顶
                if (currentScrollTop <= 0 && isFixed) {
                    updateStickyState(false);
                    lastScrollTop = currentScrollTop;
                    isScrolling = false;
                    return;
                }
                
                // 使用 requestAnimationFrame 优化性能，并增加节流
                if (rafId) {
                    return; // 如果已经有待执行的帧，直接返回
                }
                
                rafId = requestAnimationFrame(() => {
                    rafId = null;
                    // 只在滚动位置有明显变化时才检查（减少不必要的计算）
                    if (Math.abs(currentScrollTop - lastScrollTop) > 10) {
                        checkStickyState();
                        lastScrollTop = currentScrollTop;
                    }
                });
                return;
            }
            
            // 如果是在 iframe 环境中，继续执行原有的补充逻辑
            if (isInIframe) {
                // 如果滚动到顶部，强制取消吸顶
                if (currentScrollTop <= 0 && isFixed) {
                    updateStickyState(false);
                    lastScrollTop = currentScrollTop;
                    isScrolling = false;
                    return;
                }
                
                // 延迟检查吸顶状态（避免频繁调用）
                if (scrollCheckTimer) {
                    return; // 如果已经有待执行的定时器，直接返回
                }
                
                scrollCheckTimer = setTimeout(() => {
                    scrollCheckTimer = null;
                    // 只在接近顶部或接近吸顶位置时检查，避免频繁调用
                    const headerHeight = getHeaderHeight();
                    if (placeholder) {
                        const placeholderRect = placeholder.getBoundingClientRect();
                        const navtabTop = placeholderRect.top + currentScrollTop;
                        const threshold = navtabTop - headerHeight;
                        
                        // 如果接近阈值，检查吸顶状态
                        if (Math.abs(currentScrollTop - threshold) < 50) {
                            checkStickyState();
                        }
                    }
                    lastScrollTop = currentScrollTop;
                }, 150); // 增加防抖时间到150ms
            } else {
                lastScrollTop = currentScrollTop;
            }
        }, { passive: true });

        function getOffset(el) {
            let box = el.getBoundingClientRect();
            let body = document.body;
            let clientTop = el.clientTop || body.clientTop || 0;
            let clientLeft = el.clientLeft || body.clientLeft || 0;
            let scrollTop = window.scrollY || el.scrollTop;
            let scrollLeft = window.scrollX || el.scrollLeft;
            return {
                top: box.top + scrollTop - clientTop,
                left: box.left + scrollLeft - clientLeft,
                scrollTop,
                scrollLeft
            };
        }

        let childList = [];
        let isLock = false;

        // 点击标签跳转
        nodes.forEach(node => {
            node.addEventListener('click', function() {
                const value = Number(node.dataset.position);
                
                // 根据 position 值获取目标节点
                // position 值对应的是 childList 的索引（从1开始），所以减1
                const targetIndex = value - 1;
                
                // 确保索引在有效范围内
                if (targetIndex < 0 || targetIndex >= childList.length) {
                    console.warn('Invalid position:', value, 'targetIndex:', targetIndex, 'childList length:', childList.length);
                    return;
                }
                
                const targetNode = childList[targetIndex];
                
                if (!targetNode) {
                    console.warn('Target node not found for position:', value, 'targetIndex:', targetIndex);
                    return;
                }
                
                // 计算偏移量：固定时需要考虑导航栏高度
                const headerHeight = getHeaderHeight();
                let offsetY = (headerHeight + 10); // 偏移量，让位置适中)
                if (targetIndex == 2) {
                    const isbrand = targetNode.id.includes('ndev_ces_brand_intro');
                    if(isbrand) {
                        offsetY = 0;
                    }
                }
                // 获取目标节点的实际位置
                const targetOffset = getOffset(targetNode).top - offsetY;
                
                window.scrollTo({
                    top: Math.max(0, targetOffset),
                    behavior: 'smooth'
                });

                isLock = true;
                nodes.forEach(n => {
                    n.classList.remove('selected');
                });
                node.classList.add('selected');
                window.dataLayer.push({
                    event:"ga4Event",
                    event_name:"click_nav",
                    event_parameters:{
                        button_name: node.innerText,
                        module_name: "Ndev Ces Navtab"
                    }
                });
                // 滚动导航栏，使选中的tab完全可见
                scrollToShowTab(node);

                setTimeout(() => {
                    isLock = false;
                }, 500);
            });
        });

        let offsets = [];

        function initAllNodes() {
            childList = [...main.childNodes].filter(item => {
                // 只获取 Shopify section 节点（id 以 shopify-section- 开头）
                return item.nodeType === 1 && item.id && item.id.startsWith('shopify-section-');
            });
            if (childList.length === 0) {
                // 如果没有找到 section 节点，尝试从第一个子节点中查找
                const firstChild = main.firstElementChild;
                if (firstChild && !firstChild.id.includes('shopify-section-template')) {
                    childList = [...firstChild.childNodes].filter(item => {
                        return item.nodeType === 1 && item.id && item.id.startsWith('shopify-section-');
                    });
                }
            }
        }

        function initOffset() {
            const arr = [];
            const headerHeight = getHeaderHeight();
            
            nodes.forEach(node => {
                const index = Number(node.dataset.position) - 1;
                const child = childList[index];
                
                if (child) {
                    // 计算偏移量：固定时需要考虑导航栏高度，减少偏移量让位置更靠上
                    const offsetY = (headerHeight + 10);
                    
                    const offsetTop = getOffset(child).top - offsetY;
                    
                    arr.push({
                        node,
                        top: Math.max(0, offsetTop)
                    });
                }
            });

            offsets = arr.sort((a, b) => a.top - b.top);
        }

        let currentIndex = -1;

        /**
         * 滚动导航栏，使选中的tab完全可见，并多滚动一个tab的宽度
         * @param {HTMLElement} selectedNode - 选中的tab节点
         */
        function scrollToShowTab(selectedNode) {
            if (!selectedNode || !scrollableContainer) {
                return;
            }

            // 获取可滚动容器的边界
            const containerRect = scrollableContainer.getBoundingClientRect();
            const containerLeft = containerRect.left;
            const containerRight = containerRect.right;

            // 获取选中tab的边界
            const tabRect = selectedNode.getBoundingClientRect();
            const tabLeft = tabRect.left;
            const tabRight = tabRect.right;
            const tabWidth = tabRect.width;

            // 边距（左右各20px）
            const margin = 20;

            // 检查tab是否完全在视口内，并留有20px边距
            const isFullyVisible = tabLeft >= (containerLeft + margin) && tabRight <= (containerRight - margin);

            if (!isFullyVisible) {
                // 计算需要滚动的距离
                let scrollLeft = scrollableContainer.scrollLeft;

                if (tabLeft < (containerLeft + margin)) {
                    // tab在左侧被遮挡或边距不足，向左滚动，多滚动一个tab的宽度
                    scrollLeft = scrollLeft - (containerLeft + margin - tabLeft) - tabWidth;
                } else if (tabRight > (containerRight - margin)) {
                    // tab在右侧被遮挡或边距不足，向右滚动，多滚动一个tab的宽度
                    scrollLeft = scrollLeft + (tabRight - (containerRight - margin)) + tabWidth;
                }

                // 平滑滚动到目标位置
                scrollableContainer.scrollTo({
                    left: Math.max(0, scrollLeft),
                    behavior: 'smooth'
                });
            }
        }

        // 根据滚动位置自动高亮对应标签
        function checkActiveTab(scrollTop) {
            if (isLock) {
                return false;
            }
            
            const headerHeight = getHeaderHeight();
            const offset = (headerHeight + 10); // 与跳转逻辑保持一致
            scrollTop = scrollTop + offset;
            
            offsets.forEach((item, i) => {
                if (!item) {
                    return false;
                }
                
                if (scrollTop >= item.top) {
                    const next = offsets[i + 1]?.top;
                    if (next && scrollTop < next && currentIndex !== i) {
                        currentIndex = i;
                        nodes.forEach(n => {
                            n.classList.remove('selected');
                        });
                        item.node.classList.add('selected');
                        // 滚动导航栏，使选中的tab完全可见
                        scrollToShowTab(item.node);
                    } else if (!next && currentIndex !== i) {
                        currentIndex = i;
                        nodes.forEach(n => {
                            n.classList.remove('selected');
                        });
                        item.node.classList.add('selected');
                        // 滚动导航栏，使选中的tab完全可见
                        scrollToShowTab(item.node);
                    }
                }
            });
        }

        // 初始化视口观察器，监听 navtab 是否在视口内
        function initViewportObserver() {
            if (viewportObserver) {
                viewportObserver.disconnect();
            }
            
            viewportObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    // 如果 navtab 不在视口内，移除所有 tab 的选中态
                    if (!entry.isIntersecting) {
                        nodes.forEach(n => {
                            n.classList.remove('selected');
                        });
                        currentIndex = -1; // 重置当前索引
                    }
                });
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0 // 只要有任何部分不在视口内就触发
            });
            
            // 观察 navtab section
            viewportObserver.observe(navtabSection);
        }
        
        // 初始化
        setTimeout(() => {
            initStickyObserver();
            initViewportObserver();
            initAllNodes();
            initOffset();
            checkActiveTab(window.scrollY || document.documentElement.scrollTop);
        }, 1000);
        
        // 监听滚动事件
        let offsetTimer = null;
        window.addEventListener('scroll', function() {
            // 检查活动标签
            checkActiveTab(window.scrollY || document.documentElement.scrollTop);
            
            // 延迟更新偏移量
            clearTimeout(offsetTimer);
            offsetTimer = setTimeout(() => {
                initOffset();
            }, 2000);
        }, { passive: true });
    };
})();